import { useCallback, useMemo } from 'react';

import { ConfigurationFeaturesList } from 'common/enums/featuresList.enum';
import { FeatureActions } from 'common/models/roles-and-access/roleAccess.model';
import { useRolesAndAccess } from 'common/providers/AccessProvider';

function useVideoLinkAccess() {
    const { featuresActions } = useRolesAndAccess();

    const setUpVideoLink = useMemo(
        () =>
            featuresActions.find(
                (ele: FeatureActions) =>
                    ele.featureKey === ConfigurationFeaturesList.SET_UP_VIDEO_LINK
            ),
        [featuresActions]
    );

    const getSetUpVideoLinkDisabled = useCallback((setUpVideoLink: FeatureActions) => {
        if (!setUpVideoLink.read && !setUpVideoLink.write) {
            return true;
        }
        return setUpVideoLink.read != setUpVideoLink.write;
    }, []);

    return {
        isSetUpDisabled:
            setUpVideoLink != undefined ? getSetUpVideoLinkDisabled(setUpVideoLink) : true
    };
}

export default useVideoLinkAccess;
